import React from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

const OfflineBanner = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-urgent-orange text-white text-xs font-bold uppercase tracking-wider py-2 px-4 text-center sticky top-0 z-[200] shadow-md border-b border-black/20 flex items-center justify-center gap-2 animate-fadeIn"
    >
      <span aria-hidden="true">📡</span>
      <span>You are currently offline. Local changes will sync automatically when reconnected.</span>
    </div>
  );
};

export default OfflineBanner;
